import { render, staticRenderFns } from "./intro_assistant.vue?vue&type=template&id=61e39d57&"
import script from "./intro_assistant.vue?vue&type=script&lang=js&"
export * from "./intro_assistant.vue?vue&type=script&lang=js&"
import style0 from "./intro_assistant.vue?vue&type=style&index=0&id=61e39d57&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports